import type { ModalProps } from "@msuite/ui/modal";
import { Fragment } from "react";
import { motion } from "motion/react";
import { cn } from "@msuite/ui/utils";

export function InsightsSpotlightBackdrop({ onClose }: Pick<ModalProps, "onClose">) {
	/** Render */
	return (
		<Fragment>
			<motion.div
				className="absolute inset-0 bg-linear-180 from-black/50 to-black/30 backdrop-grayscale-100"
				onClick={onClose}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0, transition: { duration: 0.2 } }}
			/>
			<motion.div
				className="absolute inset-0 blur-xl pointer-events-none"
				initial={{ opacity: 0, scale: 1.05 }}
				animate={{ opacity: 1, scale: 1 }}
				exit={{ opacity: 0, scale: 1.05 }}
				transition={{ duration: 0.5 }}
			>
				<div
					className={cn(
						"absolute -inset-6 overflow-hidden",
						"[mask-image:linear-gradient(#000,#000),linear-gradient(#000,#000)]",
						"[mask-size:100%_100%,calc(100%-2rem)_calc(100%-2rem)]",
						"[mask-position:center,center] [mask-repeat:no-repeat] [mask-composite:exclude]",
					)}
				>
					<div
						className={cn(
							"absolute -inset-1/2 animate-[spin_5s_linear_infinite]",
							"bg-conic/decreasing from-violet-700 via-lime-300 to-violet-700",
						)}
					/>
				</div>
			</motion.div>
		</Fragment>
	);
}
